import { OrganizationType } from 'globalTypes';

import Organization from 'entities/Organization';
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';

class Organizations extends Collection<Organization> {
  initialize() {
    // @ts-ignore tsc doesnt like this way of initializing model
    this.model = Organization;
  }

  static suggest(): Promise<Organizations> {
    return apiRequest('/organizations/suggested', 'GET').then(response =>
      Organizations.fromJSON(response)
    ) as Promise<Organizations>;
  }

  static search(
    queryType: OrganizationType,
    query: string,
    page: number = 1,
    perPage: number = 20
  ) {
    const options = {
      type: queryType.toLowerCase(),
      query,
      page,
      per_page: perPage,
    };

    return apiRequest('/organizations/find', 'GET', options).then(response =>
      Organizations.fromJSON(response)
    ) as Promise<Organizations>;
  }
}

export default Organizations;
